import { Pipe, PipeTransform } from '@angular/core';

import { RestockOrderState } from 'src/shared/services/restocking-orders.service';

/**
 * Single source of truth for restock-order state labels so the detail page,
 * history page, item-level chips, and the Restocking page all render identical
 * text — item statuses are the order's status, never a separate vocabulary.
 */
export function stateLabel(state: RestockOrderState, short = false): string {
  switch (state) {
    case 'preview':
      return short ? 'Preview' : 'Preview — Concierge Reviewing';
    case 'finalizing':
      return 'Finalizing Cart';
    case 'ordered':
      return 'Ordered';
    case 'delivered':
      return 'Delivered';
    case 'restocked':
      return 'Restocked';
    case 'cancelled':
      return 'Cancelled';
    default:
      return '';
  }
}

@Pipe({
  name: 'restockStateLabel',
  standalone: true
})
export class RestockStateLabelPipe implements PipeTransform {
  transform(state: RestockOrderState, short = false): string {
    return stateLabel(state, short);
  }
}

/**
 * Formats a dollar amount (the model stores dollars, not cents) as `$1,234.56`.
 * The existing `tcurrency` pipe divides by 100, so it can't be reused here.
 * Exported so pages can precompute display strings in TS (avoids template calls).
 */
export function formatMoney(value: number): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }
  const [whole, decimals] = Math.abs(value).toFixed(2).split('.');
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${value < 0 ? '-$' : '$'}${withCommas}.${decimals}`;
}

@Pipe({
  name: 'restockMoney',
  standalone: true
})
export class RestockMoneyPipe implements PipeTransform {
  transform(value: number): string {
    return formatMoney(value);
  }
}
